import React from 'react';
import { useState } from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Button, Box } from '@mui/material';
import ProgramSetup from './ProgramSetup';
import AddOns from './AddOns';

const ProgramConfiguration = ({ view, setTab, ClientId, ProjectId, EstimationId, Version }) => {
  const [activeTab, setActiveTab] = useState('program-setup');
  // for program setup tab change
  const [formState, setFormState] = useState({
    InstanceTypeValue: 'NA',
    ProgramTypeValue: 'NA'
  });

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleNext = () => {
    setTab('Client-Custom-Change');
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={activeTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} textColor="secondary" indicatorColor="secondary" aria-label="lab API tabs example">
            <Tab label="Program Setup" value="program-setup" />
            <Tab label="Add-Ons" value="add-ons" />
          </TabList>
        </Box>
        <TabPanel value="program-setup">
          <ProgramSetup
            view={view}
            ClientId={ClientId}
            ProjectId={ProjectId}
            EstimationId={EstimationId}
            Version={Version}
            formState={formState}
            setFormState={setFormState}
          />
        </TabPanel>
        <TabPanel value="add-ons">
          <AddOns view={view} ClientId={ClientId} ProjectId={ProjectId} EstimationId={EstimationId} Version={Version} formState={formState} />
        </TabPanel>
      </TabContext>

      <Button
        size="1.3rem"
        type="button"
        variant="contained"
        color="secondary"
        sx={{ marginTop: '10px', visibility: view ? 'hidden' : 'visible' }}
        onClick={handleNext}
      >
        Next
        <NavigateNextIcon />
      </Button>
    </Box>
  );
};

export default ProgramConfiguration;
